//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { gql } from 'graphql-tag'
import { required } from 'vuelidate/lib/validators'

const DATA_QUERY = gql`
  query {
    websiteJobFunctions {
      id
      name
    }
  }
`

const UPDATE_USER = gql`
  mutation ($data: UserUpdateInput) {
    updateUser(data: $data) {
      id
      company
      jobFunctionId
    }
  }
`

export default {
  name: 'CompleteAccountModal',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      submitted: false,
      jobFunctions: [],
      company: null,
      jobFunction: null
    }
  },
  computed: {
    account() {
      return this.$store.get('user/user') || null
    }
  },
  watch: {
    active: {
      immediate: true,
      handler(active) {
        if (active) this.loadJobFunctions()
      }
    }
  },
  validations: {
    company: { required },
    jobFunction: { required }
  },
  methods: {
    async loadJobFunctions() {
      this.company = this.account?.company
      this.jobFunction = this.account?.jobFunctionId
      if (this.loading || this.jobFunctions.length) return
      this.loading = true
      try {
        const { data } = await this.$apollo.query({ query: DATA_QUERY, fetchPolicy: 'cache-first' })
        this.jobFunctions = data.websiteJobFunctions
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    async onSubmit() {
      this.submitted = true

      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          const el = document.querySelector(
            '#compete-account-form input.is-danger, #compete-account-form .v-select.is-danger input'
          )

          if (el) el.focus()
        })
        return false
      }

      try {
        this.saving = true
        const { data } = await this.$apollo.mutate({
          mutation: UPDATE_USER,
          variables: {
            data: {
              id: this.account.id,
              company: this.company,
              jobFunctionId: this.jobFunction
            }
          }
        })

        this.$store.set('user/user@company', data.updateUser[0]?.company)
        this.$store.set('user/user@jobFunctionId', data.updateUser[0]?.jobFunctionId)
        this.$emit('update:active', false)
        this.reset()
        this.$emit('onSubmit')
      } catch (error) {
        this.handleError(error)
      } finally {
        this.saving = false
      }
    },
    onClose() {
      this.$emit('update:active', false)
      this.reset()
    },
    reset() {
      this.company = this.account?.company
      this.jobFunction = this.account?.jobFunctionId
      this.submitted = false
    }
  }
}
